import React from 'react'

const FavoriteActivityDescription = ({ description }) => (
  <div className="favorite-activity-description">{description}</div>
)

FavoriteActivityDescription.displayName = 'FavoriteActivityDescription'

export default FavoriteActivityDescription
